module.exports = __webpack_public_path__ + "img/nicholas.f36e920f.jpg";